import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import "react-datepicker/dist/react-datepicker.css";

//middelware
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import Axios from "axios";


//ckeditor

import { SwalError } from "../../../../utils/constants";

import {
  create,  
  getById,  
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";


export const ManageSerieLibros = () => {
  const { SERIELIBROS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { isAdmin, userId } = useSelector(({ user }) => user);

  const history = useHistory();
  const [isCreate, setIsCreate] = useState(false);
  const [observaciones, setObservaciones] = useState("");
  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    // loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadData = async () => {
    try {
      let response = await getById(SERIELIBROS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  // prettier-ignore
  const buildObjToLoad = (response) => {
        const { 
      observaciones   
    } = response;
    setObservaciones(observaciones);
	if (isMountedRef.current) 
	setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const serieLibros = build();
    //     const notValid = validate(serieLibros);
    //     if (notValid) {
    //       setMessage(notValid);
    //       setTimeout(() => setMessage(""), 4000);
    //       return;
    //     }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} serie?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(serieLibros);
    });
  };

  const handleConfirmation = (serieLibros) => {
    let createOrUpdate = isCreate
      ? create(SERIELIBROS, serieLibros, source)
      : update(SERIELIBROS, id, serieLibros, source);
    createOrUpdate
      .then(async ({ id }) => {
        Swal.fire({
          icon: "success",
          text: `Serie ${isCreate ? "creada" : "editada"} correctamente.`,
        });

        history.push(`${ROUTES.SerieLibros.all}/${id}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => {
    return {
      userId: userId,
      observaciones,
    };
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Serie
        </button>
      );
    }
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() =>
              deleteIt(SERIELIBROS, id, ROUTES.SerieLibros.all, source)
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Serie Libro </h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>Título serie</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título serie"
              value={observaciones}
              onChange={({ target: { value } }) => {
                setObservaciones(value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
